export * from './deloitte.model';
// Private exports (to be only used by other Datastore modules)
export {
  transformDeloitteProjectDetails as _transformDeloitteProjectDetails,
} from './deloitte.transformers';
